import { Helmet } from "react-helmet-async";
import { Fragment } from "react/jsx-runtime";

const HtmlHeader = ({ title, meta, geo }) => {
    return (
        <Helmet>
            {title && <title>{title}</title>}

            {meta && (
                <Fragment>
                    {meta.description && <meta name="description" content={meta.description} />}
                    {meta.keywords && <meta name="keywords" content={meta.keywords} />}
                </Fragment>
            )}

            {geo && (
                <Fragment>
                    {geo.speakableSummary && <meta name="ai-voice-summary" content={geo.speakableSummary}></meta>}
                    {geo.jsonLD && <script type="application/ld+json">{geo.jsonLD}</script>}
                </Fragment>
            )}
        </Helmet>
    );
};

export default HtmlHeader;
